import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RequestMarkdownPanelAll from './RequestMarkdownPanelAll';

const RequestMarkdownPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RequestMarkdownPanelAll, narrow: RequestMarkdownPanelAll }}
  />
);

export default RequestMarkdownPanel;
